import React from "react";

const AirtableIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2785_806)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.8614 3.69225L2.94837 9.86308C2.11905 10.2063 2.12764 11.3843 2.96216 11.715L17.9376 17.6537C19.2535 18.1755 20.7188 18.1755 22.0345 17.6537L37.0102 11.715C37.8444 11.3843 37.8533 10.2063 37.0237 9.86308L22.1109 3.69225C20.7502 3.12927 19.2218 3.12927 17.8614 3.69225Z",
  fill: "#FCB400"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.3147 20.8966V35.7321C21.3147 36.4378 22.0262 36.9209 22.6821 36.6609L39.3693 30.1837C39.7503 30.0327 40.0002 29.6646 40.0002 29.2549V14.4194C40.0002 13.7138 39.2886 13.2306 38.6327 13.4906L21.9455 19.9678C21.5648 20.1188 21.3147 20.4869 21.3147 20.8966Z",
  fill: "#18BFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.4181 21.6621L12.4657 24.0533L11.9628 24.2963L1.50863 29.3055C0.845946 29.6252 0.00012207 29.1423 0.00012207 28.4061V14.4818C0.00012207 14.2154 0.136684 13.9855 0.319821 13.8123C0.396242 13.7356 0.482836 13.6726 0.572823 13.6226C0.822658 13.4727 1.17899 13.4327 1.48195 13.5525L17.3349 19.8337C18.1407 20.1534 18.204 21.2825 17.4181 21.6621Z",
  fill: "#F82B60"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.4181 21.6621L12.4657 24.0533L0.319824 13.8123C0.396245 13.7356 0.482839 13.6726 0.572825 13.6226C0.822661 13.4727 1.17899 13.4327 1.48196 13.5525L17.3349 19.8337C18.1407 20.1534 18.204 21.2825 17.4181 21.6621Z",
  fill: "black",
  fillOpacity: 0.25
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2785_806"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "white"
}))));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(AirtableIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;